module.exports = "<div class=\"zizHeader logo text-center\">\r\n<img src=\"assets/img/ziz.png\" class=\"logo-img\" (click)=\"redirectpage()\">\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/adv-header-before-signup.component.html
// module id = 1073
// module chunks = 31